import React, { useEffect } from "react";
import { examConfig } from "../../../../config/examConfig";

const SecurityWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useEffect(() => {
        if (!examConfig.enableCheatingDetection) {
            return; // Skip security restrictions if cheating detection is disabled
        }

        // Disable Right Click
        const disableRightClick = (event: MouseEvent) => {
            event.preventDefault();
        };

        // Disable Key Combinations
        const disableKeys = (event: KeyboardEvent) => {
            if (
                event.ctrlKey &&
                ["u", "U", "c", "C", "x", "X", "v", "V", "i", "I", "j", "J"].includes(event.key)
            ) {
                event.preventDefault();
            }

            if (
                event.metaKey &&
                ["u", "U", "c", "C", "x", "X", "v", "V", "i", "I", "j", "J"].includes(event.key)
            ) {
                event.preventDefault();
            }

            // Disable F12
            if (event.key === "F12") {
                event.preventDefault();
            }
        };

        // Disable Copy-Paste
        const disableCopyPaste = (event: ClipboardEvent) => {
            event.preventDefault();
        };

        document.addEventListener("contextmenu", disableRightClick);
        document.addEventListener("keydown", disableKeys);
        document.addEventListener("copy", disableCopyPaste);
        document.addEventListener("paste", disableCopyPaste);

        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
            document.removeEventListener("keydown", disableKeys);
            document.removeEventListener("copy", disableCopyPaste);
            document.removeEventListener("paste", disableCopyPaste);
        };
    }, []);

    return <>{children}</>;
};

export default SecurityWrapper;
